<!--@format-->
<template>
    <div class="account-company-monthly-quotas-widget">
        <div class="widget-contents-container">
            <div class="widget-header">
                <h3>Edit Monthly Quotas</h3>
                <div class="svg-container widget-close-button" @click="closeWidget">
                    <widget-close-svg />
                </div>
            </div>
            <div class="content-wrapper">
                <app-button class="averages-btn" @click="populateAverages()">
                    Use National Averages
                </app-button>
                <div class="bordered-container">
                    <div class="title monthly-quota-title">Monthly Quotas</div>
                    <div v-if="loading" class="loading-card">
                        <loading-screen-svg />
                    </div>
                    <div v-else class="form-group">
                        <app-input v-model="monthlyLeadQuota" label="Qualified Lead Quota" />
                        <app-input v-model="monthlyRevenueQuota" label="Gross Revenue Quota" />
                        <app-input v-model="monthlyMarginQuota" label="Gross Margin Quota" />
                        <app-input v-model="monthlyMrrQuota" label="MRR Quota" />
                    </div>
                </div>
                <div class="bordered-container">
                    <div class="title converstion-title">My sales team can convert...</div>
                    <div v-if="loading" class="loading-card">
                        <loading-screen-svg />
                    </div>
                    <div v-else class="form-group">
                        <app-input v-model="appointmentPercent" label="% of SQ leads to meetings" />
                        <app-input
                            v-model="proposalPercent"
                            label="% of meetings to opportunities"
                        />
                        <app-input v-model="closePercent" label="% of opportunities to won deals" />
                        <app-input v-model="averageMsa" label="Average Opportunity Gross Revenue" />
                    </div>
                </div>
            </div>
            <div class="widget-footer">
                <div class="cancel-container">
                    <app-button class="cancel-btn" @click="closeWidget"> Cancel </app-button>
                </div>
                <div class="action-container">
                    <app-button @click="save()">Save</app-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button.vue');
const AppInput = () => import('@/components/common/app-input');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg.vue');
const LoadingScreenSvg = () => import('@/components/svg/loading-screen-svg');

import EventBus from '@/scripts/event-bus.js';

export default {
    name: 'account-company-monthly-quotas-widget',

    components: {
        'app-button': AppButton,
        'app-input': AppInput,
        'widget-close-svg': WidgetCloseSvg,
        'loading-screen-svg': LoadingScreenSvg,

    },

    props: {
        widget: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            loading: true,
            clientId: this.widget.clientId,
            monthlyLeadQuota: 0,
            averageMsa: 0,
            monthlyRevenueQuota: 0,
            monthlyMarginQuota: 0,
            monthlyMrrQuota: 0,
            appointmentPercent: 0,
            proposalPercent: 0,
            closePercent: 0,
        };
    },

    created() {
        this.getMetrics();
    },

    methods: {
        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        populateAverages() {
            this.monthlyLeadQuota = 20;
            this.averageMsa = 2500;
            this.monthlyRevenueQuota = 30000;
            this.monthlyMarginQuota = 20000;
            this.monthlyMrrQuota = 15000;
            this.appointmentPercent = 20;
            this.proposalPercent = 50;
            this.closePercent = 50;
        },

        save() {
            var changes = [
                {
                    name: 'MonthlyLeadQuota',
                    value: this.monthlyLeadQuota,
                },
                {
                    name: 'AverageMsa',
                    value: this.averageMsa,
                },
                {
                    name: 'MonthlyRevenueQuota',
                    value: this.monthlyRevenueQuota,
                },
                {
                    name: 'MonthlyMarginQuota',
                    value: this.monthlyMarginQuota,
                },
                {
                    name: 'MonthlyMrrQuota',
                    value: this.monthlyMrrQuota,
                },
                {
                    name: 'AppointmentPercent',
                    value: this.appointmentPercent,
                },
                {
                    name: 'ProposalPercent',
                    value: this.proposalPercent,
                },
                {
                    name: 'ClosePercent',
                    value: this.closePercent,
                },
            ];

            this.$api
                .patch(`/api/Clients/${this.clientId}`, changes)
                .then(() => {
                    this.$helpers.showSuccessNotification('Your changes have been saved.');
                    EventBus.$emit('monthly-quota:update');
                    EventBus.$emit('close-widget', this.widget);
                })
                .catch((error) => {
                    this.$helpers.showFailNotification(
                        'An error occurred while saving your information.',
                        { error },
                    );
                });
        },

        getMetrics() {
            this.loading = true;
            var select = '$select=MonthlyLeadQuota,AverageMsa,MonthlyRevenueQuota,MonthlyMarginQuota,MonthlyMrrQuota,AppointmentPercent,ProposalPercent,ClosePercent';
            var filter = `$filter=Id eq ${this.clientId}`;
            var query = `/service/Clients?${filter}&${select}`;
            
            this.$api
                .get(query)
                .then((response) => {
                    var responseData = response.data.value[0];

                    this.monthlyLeadQuota = responseData.MonthlyLeadQuota;
                    this.averageMsa = responseData.AverageMsa;
                    this.monthlyRevenueQuota = responseData.MonthlyRevenueQuota;
                    this.monthlyMarginQuota = responseData.MonthlyMarginQuota;
                    this.monthlyMrrQuota = responseData.MonthlyMrrQuota;
                    this.appointmentPercent = responseData.AppointmentPercent;
                    this.proposalPercent = responseData.ProposalPercent;
                    this.closePercent = responseData.ClosePercent;
                })
                .catch((error) => {
                    this.$helpers.showFailNotification(
                        'An error occurred while fetching your information.',
                        { error },
                    );
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>

<style>
.account-company-monthly-quotas-widget .form-group {
    margin-top: 1em;
}

.account-company-monthly-quotas-widget .app-input {
    margin-bottom: 1em;
}

.account-company-monthly-quotas-widget .bordered-container {
    position: relative;
    border: 2px solid #e9e9ef;
    border-radius: 22px;
    margin: 25px 0;
    padding: 10px 20px;
}

.account-company-monthly-quotas-widget .bordered-container .title {
    position: absolute;
    top: -11px;
    left: 50%;
    padding: 0px 25px;
    background-color: #ffffff;
    font-weight: 600;
}

.account-company-monthly-quotas-widget .bordered-container .loading-card {
    text-align: center;
}

.account-company-monthly-quotas-widget .monthly-quota-title {
    margin-left: -82px;
}

.account-company-monthly-quotas-widget .converstion-title {
    margin-left: -129px;
}

.account-company-monthly-quotas-widget .averages-btn {
    margin: 0 auto;
    background: #2ada2b;
}

.account-company-monthly-quotas-widget .averages-btn:hover {
    background: #1d9e1e;
}

.account-company-monthly-quotas-widget .cancel-btn {
    background: transparent;
    color: #877d88;
    border: none;
}

.account-company-monthly-quotas-widget .cancel-btn:hover {
    background: #e9e9ef;
}
</style>
